export default __webpack_public_path__ + "static/nighthawk-e8645d4c366557439d1b32862db8d1c8.webp";